// index-lifecycle edit planner (v2 Slice C5).
//
// PRD: Ralph/DdlStructuralEdit2/PRD.md § Slice C5.
//
// Appends a fresh dialect-correct lifecycle statement after the source
// statement (DSE2-7: no coalescing by default). Source kind is unrestricted —
// callers can drive the lifecycle op against any DDL statement (CREATE INDEX
// seed, ALTER TABLE, DROP INDEX) since the lifecycle command is independent
// of the source.

import { rangeFromOffsets } from '../../../sql-grammar/document/lineIndex';
import type { DdlEdit, PlannedByteEdit } from '../../types';

import { pickAppendInsertion } from './appendInsertion';
import type { DdlEditCtx } from './applyDdlEdit';
import { synthesizeIndexLifecycle } from './dialect.indexLifecycle';

type IndexLifecycleEdit = Extract<DdlEdit, { op: 'index-lifecycle' }>;

export function planIndexLifecycleEdit(
  ctx: DdlEditCtx,
  edit: IndexLifecycleEdit,
): readonly PlannedByteEdit[] {
  const synth = synthesizeIndexLifecycle(ctx.engine, edit.lifecycle);
  const { offset: insertAt, sep, trailSep } = pickAppendInsertion(
    ctx.source,
    ctx.statementInfo.range.endOffset,
  );
  return [{
    range: rangeFromOffsets(ctx.lineIdx, insertAt, insertAt),
    replacement: sep + synth + trailSep,
    rationale: `index-lifecycle:${edit.lifecycle.kind}`,
  }];
}
